import { cx } from "class-variance-authority";

type InteractiveLabelProps = { interactivity: "interactive"; htmlFor: string };
type NonInteractiveLabelProps = {
  interactivity: "non-interactive";
  id: string;
};
type LabelProps = {
  text: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  labelSize?: "small" | "base";
} & (InteractiveLabelProps | NonInteractiveLabelProps);

export const Label = (props: LabelProps) => {
  const className = cx(
    "flex items-center",
    "font-medium",
    props.labelSize === "small" ? "text-sm" : "text-base",
    props.isRequired && "gap-x-0.5",
    props.isDisabled ? "text-medium-hippo" : "text-charcoal",
  );
  const children = (
    <>
      <span>{props.text}</span>
      {props.isRequired ? <RequiredStar /> : null}
    </>
  );

  return (
    <>
      {props.interactivity === "interactive" ? (
        <label className={className} htmlFor={props.htmlFor}>
          {children}
        </label>
      ) : (
        <p className={className} id={props.id}>
          {children}
        </p>
      )}
    </>
  );
};

export const RequiredStar = () => {
  return (
    <span className="text-ui-red" aria-hidden={true}>
      *
    </span>
  );
};
